import React, { useState, useEffect, useContext } from "react";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { IoCloseOutline } from "react-icons/io5";
import '../settings.scss';
import { AuthContext } from "../../../context/AuthContext";
import masterApi from "../../../services/masterApi";


export default function ResetPassword({ closePopup }) {
    const [isCurrentPasswordVisible, setIsCurrentPasswordVisible] = useState(false);
    const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
    const [isConfirmNewPasswordVisible, setIsConfirmNewPasswordVisible] = useState(false);
    const {
        register,
        handleSubmit,
        getValues,
        formState: { errors },
      } = useForm();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const navigate = useNavigate();
    const { handleLogout } = useContext(AuthContext);
  const toggleCurremtPasswordVisibility = () => {
    setIsCurrentPasswordVisible((prev) => !prev);
  };
  const toggleNewPasswordVisibility = () => {
    setIsNewPasswordVisible((prev) => !prev);
  };
  const toggleConfirmNewPasswordVisibility = () => {
    setIsConfirmNewPasswordVisible((prev) => !prev);
  };

  const onSubmit = async (data) => {  debugger
    try {
      const userData = await masterApi.resetPassword({ data });
      if (userData?.data?.ok) {
        setSuccess("Password reset successfully. Redirecting...");
        setTimeout(() => {
          handleLogout();
        }, 2000);
      } else {
        setError(error.response?.data?.message || "Failed to reset password.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong!");
      console.error("Password reset failed:", err.message);
    }
  };
  const onReset = () => {
    navigate("../");
  };
  return (
    <div className="popup-container center-popup">
      <div className="shadeClose" onClick={closePopup}></div>
      <div className="popup-inner">
        <div className="inner-design">
          <div className="popup-header d-flex align-items-center gap-2">
            <h2>
            Reset Password
            </h2>
            <button type="button" className="ms-auto close-btn" onClick={closePopup}>
              <IoCloseOutline />
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="popup-content">
              <div className="row">
                 <div className="col-12 col-md-12 mb-4">
                          <label className="form-label" >
                           Current  Password
                          </label>
                          <div className="position-relative password-toggle ">
                            <input
                            {...register("oldpassword", { required: "Old Password is required" })}
                              type={isCurrentPasswordVisible ? "text" : "password"}
                               placeholder="Enter Current Password" 
                               className= {`input ${errors.oldpassword ?"form-control ps-2 required" : "form-control ps-2" }`}
                
                            />
                            <span
                              onClick={toggleCurremtPasswordVisibility}
                
                            >
                              {isCurrentPasswordVisible ? <LuEyeOff /> : <LuEye />}
                            </span>
                          </div>
                
                        </div>

                        <div className="col-12 col-md-12 mb-4">
                          <label className="form-label" >
                           New  Password
                          </label>
                          <div className="position-relative password-toggle ">
                            <input
                            {...register("newpassword", {
                              required: "New Password is required",
                              pattern: {
                                value: new RegExp(process.env.REACT_APP_PASSWORD_REGEX),
                                message:
                                  "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$&*)",
                              },
                            })}
                              type={isNewPasswordVisible ? "text" : "password"}
                               placeholder="Enter New Password" 
                               className={`input ${errors.newpassword ? "form-control ps-2 required " : "form-control ps-2"  }`}
                
                            />
                            <span
                              onClick={toggleNewPasswordVisibility}
                
                            >
                              {isNewPasswordVisible ? <LuEyeOff /> : <LuEye />}
                            </span>
                          </div>
                
                        </div>
                        <div className="col-12 col-md-12">
                          <label className="form-label" >
                           Confirm  Password
                          </label>
                          <div className="position-relative password-toggle ">
                            <input
                            {...register("confirmpassword", {
                              required: "Confirm Password is required",
                              validate: {
                                passwordEqual: (value) =>
                                  value === getValues().newpassword || "Passwords do not match",
                              },
                            })}
                              type={isConfirmNewPasswordVisible ? "text" : "password"}
                               placeholder="Enter New Password" 
                               className={`input ${errors.confirmpassword ? "form-control ps-2 required" : "form-control ps-2"
                                    }`}
                
                            />
                            <span
                              onClick={toggleConfirmNewPasswordVisibility}
                
                            >
                              {isConfirmNewPasswordVisible ? <LuEyeOff /> : <LuEye />}
                            </span>
                          </div>
                
                        </div>

              </div>
            </div>

            {/* Footer Buttons */}
            <div className="popup-footer position-absolute w-100 d-flex">
              <div className="ms-auto d-flex gap-2">
                <button type="button" className="btn btn-dark" onClick={closePopup}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success">
                  Create
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
